import React, { useCallback, useContext } from 'react';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { AnalyticContext } from './common/controllers/analytic-context/index.tsx';
import { MEATBALL_DROPDOWN } from './common/constants.tsx';
import { CreateRoadmapButton } from './CreateRoadmapButton.tsx';
import { MoreNavMenuButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/main.tsx';
import { HideL1MenuItemSection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/hide-l1-menu-item-action/index.tsx';
import { L1_MENU_ID } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import MenuGroup from '@atlaskit/menu/menu-group';
import { fg } from '@atlassian/jira-feature-gating';

const roadmaps = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-roadmaps.common.action-buttons-static.roadmaps',
	defaultMessage: 'Roadmaps',
	description: 'Label for the roadmaps section in sidebar navigation',
});

const MenuItems = () => (
	<MenuGroup>
		<HideL1MenuItemSection menuId={L1_MENU_ID.ROADMAPS} hasSeparator={false} />
	</MenuGroup>
);

export const ActionButtons: () => React.JSX.Element = () => {
	const { formatMessage } = useIntl();
	const { fireUIAnalyticForFixButton } = useContext(AnalyticContext);
	const handleNavMenuOpen = useCallback(() => {
		fireUIAnalyticForFixButton({ itemId: MEATBALL_DROPDOWN });
	}, [fireUIAnalyticForFixButton]);

	return (
		<>
			<CreateRoadmapButton />
			{!fg('navx-global-side-nav') && (
				<MoreNavMenuButton
					onOpen={handleNavMenuOpen}
					MenuItems={MenuItems}
					name={formatMessage(roadmaps)}
				/>
			)}
		</>
	);
};
